<template>
  <v-card>
    <form-header
      :fullscreen="true"
      :form="form"
      tour="booking-payments-form"
      :title="$lang('booking-payment-providers.title')"
      with-close
      @cancel="cancel()"
    >
      <template v-slot:toolbar-items>
        <v-btn dark text @click="cancel()">{{ $lang("main.close") }}</v-btn>
      </template>
    </form-header>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" md="8">
            <v-alert v-show="isShowPropertyWarning" type="info">
              <v-row align="center">
                <v-col class="grow">
                  {{
                    $lang(
                      "booking-payment-providers.helps.property_override_info"
                    )
                  }}
                </v-col>
                <v-col class="shrink">
                  <v-btn :to="{ name: 'companies' }">{{
                    $lang("companies.title")
                  }}</v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <v-container>
              <v-row v-if="isInherit">
                <v-col cols="12" xs="12" md="12">
                  <v-card flat>
                    <template v-if="isInherited">
                      <v-card-title>
                        <v-btn
                          block
                          small
                          @click.stop="openInherit('override')"
                        >
                          <v-icon>mdi-backup-restore</v-icon>
                          {{ $lang("booking-payment-providers.override") }}
                          {{ $lang("booking-payment-providers.override_hint") }}
                        </v-btn>
                      </v-card-title>
                    </template>
                    <v-card-title v-else>
                      <v-btn block small @click.stop="openInherit('inherit')">
                        <v-icon>mdi-backup-restore</v-icon>
                        {{ $lang("booking-payment-providers.inherit") }}
                      </v-btn>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="$can('BETA_FEATURE')" cols="12" md="12">
                  <v-card :disabled="isInherited">
                    <v-card-title class="pt-4 pb-0">
                      <div>
                        <span class="text-h6">
                          {{ $lang("payments-planned.settings.title") }}
                        </span>
                        <v-chip
                          small
                          class="white--text text-caption ml-3 pa-2"
                          color="blue"
                        >
                          {{ $lang("payments-planned.settings.new") }}
                        </v-chip>
                      </div>
                      <v-spacer></v-spacer>
                      <v-dialog
                        max-width="900"
                        @click:outside="
                          clearTemporaryChanges('paymentAutomationForm')
                        "
                        @keydown.esc="
                          clearTemporaryChanges('paymentAutomationForm')
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-body-2 pt-2 pb-2 text-uppercase"
                            v-bind="attrs"
                            v-on="on"
                            @click="
                              mountStripeConnectOnboardingSessionElement()
                            "
                          >
                            {{ $lang("payments-planned.settings.configure") }}
                          </v-btn>
                        </template>
                        <template v-slot:default="paymentAutomationDialog">
                          <v-card class="pa-4">
                            <v-card-text class="pa-0">
                              <div class="d-flex mb-6">
                                <v-btn
                                  large
                                  icon
                                  @click="
                                    paymentAutomationDialog.value = false;
                                    clearTemporaryChanges(
                                      'paymentAutomationForm'
                                    );
                                  "
                                  class="mr-4 align-self-center"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <div class="align-self-center">
                                  <span class="text-h5 black--text">{{
                                    $lang(
                                      "payments-planned.configuration.title"
                                    )
                                  }}</span>
                                </div>
                              </div>
                              <div
                                class="pl-4 pr-4"
                                v-if="
                                  !isConnectOnboardingSessionSuccessful &&
                                  !collection.find(
                                    (paymentProvider) =>
                                      paymentProvider.type ===
                                      $const(
                                        'ConstBookingPaymentProviderTypes',
                                        'PAYMENT_AUTOMATION'
                                      )
                                  )
                                "
                              >
                                <div
                                  class="d-flex"
                                  v-if="
                                    isLoadingStripeConnectInstance ||
                                    isLoadingStripeConnectOnboardingSession
                                  "
                                >
                                  <v-progress-circular
                                    color="primary"
                                    class="mt-12 mb-12 ml-auto mr-auto"
                                    :size="24"
                                    :width="2"
                                    indeterminate
                                  ></v-progress-circular>
                                </div>
                                <div
                                  v-else-if="
                                    isConnectOnboardingSessionSuccessful !==
                                    true
                                  "
                                  id="embedded-onboarding-container"
                                ></div>
                              </div>
                              <div v-else class="pl-4 pr-4">
                                <div
                                  class="d-flex"
                                  v-if="isLoadingPaymentAutomationConfig"
                                >
                                  <v-progress-circular
                                    color="primary"
                                    class="mt-12 mb-12 ml-auto mr-auto"
                                    :size="24"
                                    :width="2"
                                    indeterminate
                                  ></v-progress-circular>
                                </div>
                                <div
                                  v-if="!isLoadingPaymentAutomationConfig"
                                  class="pt-3 pb-3 pl-4 pr-4 rounded-lg d-flex align-center mb-3 grey lighten-4"
                                >
                                  <div
                                    class="text-subtitle-1 font-weight-medium mr-6"
                                  >
                                    {{
                                      $lang(
                                        "payments-planned.configuration.active_method"
                                      )
                                    }}
                                  </div>
                                  <v-switch
                                    v-model="
                                      temporaryFormsData.paymentAutomationForm
                                        .status
                                    "
                                    color="primary"
                                    class="mt-0 pt-0"
                                    hide-details
                                    :label="
                                      temporaryFormsData.paymentAutomationForm
                                        .status
                                        ? $lang('main.yes')
                                        : $lang('main.no')
                                    "
                                  ></v-switch>
                                </div>
                                <div
                                  v-if="
                                    !isLoadingPaymentAutomationConfig &&
                                    temporaryFormsData.paymentAutomationForm
                                      .status
                                  "
                                  class="mb-2 pl-4 pr-4"
                                >
                                  <c-reservation-sources
                                    class="mb-2 pt-0 mt-0"
                                    v-model="
                                      temporaryFormsData.paymentAutomationForm
                                        .data.excluded_reservation_sources
                                    "
                                    :label="
                                      $lang(
                                        'payments-planned.configuration.excluded_sources_label'
                                      )
                                    "
                                    :defaultSelection="true"
                                    :hideDetails="true"
                                    :clearable="true"
                                    :multiple="true"
                                    :hidden="[5]"
                                  />
                                  <span>{{
                                    $lang(
                                      "payments-planned.configuration.excluded_sources_hint"
                                    )
                                  }}</span>
                                </div>
                                <div
                                  class="pl-3 pr-3 pt-2 mt-0"
                                  v-if="
                                    temporaryFormsData.paymentAutomationForm
                                      .status &&
                                    !isLoadingPaymentAutomationConfig
                                  "
                                >
                                  <v-checkbox
                                    v-model="
                                      temporaryFormsData.paymentAutomationForm
                                        .data.immediately_send_payment_request
                                    "
                                    :label="
                                      $lang(
                                        'payments-planned.configuration.immediately_send_notification_label'
                                      )
                                    "
                                    hide-details
                                  ></v-checkbox>
                                  <p class="ml-8 mt-2">
                                    {{
                                      $lang(
                                        "payments-planned.configuration.immediately_send_notification_hint"
                                      )
                                    }}
                                  </p>
                                </div>
                              </div>
                            </v-card-text>
                            <v-card-actions
                              class="d-flex justify-space-between pa-0 mt-15 w-100"
                            >
                              <div class="d-flex">
                                <v-btn
                                  class="mr-2"
                                  @click="
                                    paymentAutomationDialog.value = false;
                                    clearTemporaryChanges(
                                      'paymentAutomationForm'
                                    );
                                  "
                                  >{{ $lang("main.close") }}</v-btn
                                >
                              </div>
                              <v-btn
                                :disabled="
                                  (isLoadingStripeConnectInstance ||
                                    isLoadingStripeConnectOnboardingSession ||
                                    !isConnectOnboardingSessionSuccessful) &&
                                  !collection.find(
                                    (paymentProvider) =>
                                      paymentProvider.type ===
                                      $const(
                                        'ConstBookingPaymentProviderTypes',
                                        'PAYMENT_AUTOMATION'
                                      )
                                  )
                                "
                                color="success"
                                @click="
                                  updatePaymentAutomationConfiguration();
                                  paymentAutomationDialog.value = false;
                                "
                              >
                                {{ $lang("main.crud.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </v-card-title>
                    <template>
                      <v-card-text>
                        <div
                          class="text-caption grey--text text--darken-1 mt-2"
                        >
                          {{ $lang("payments-planned.settings.description") }}
                        </div>
                        <div class="mt-2">
                          <span class="text-body-2 black--text">
                            {{ $lang("payments-planned.settings.status") }}:
                          </span>
                          <v-chip
                            label
                            small
                            v-bind:class="[
                              currentFormsData.paymentAutomationForm.status
                                ? 'green darken-1 white--text'
                                : 'grey lighten-3 black--text',
                              'font-weight-medium text-caption rounded-sm px-3'
                            ]"
                            >{{
                              currentFormsData.paymentAutomationForm.status
                                ? $lang("payments-planned.settings.active")
                                : $lang("payments-planned.settings.inactive")
                            }}</v-chip
                          >
                        </div>
                      </v-card-text>
                    </template>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card :disabled="isInherited">
                    <v-card-title>
                      <span class="text-h6">
                        {{
                          $lang("booking-payment-providers.credit_card.title")
                        }}
                      </span>
                      <v-spacer></v-spacer>
                      <v-dialog
                        max-width="900"
                        @click:outside="clearTemporaryChanges('creditCardForm')"
                        @keydown.esc="clearTemporaryChanges('creditCardForm')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-body-2 pt-2 pb-2 text-uppercase"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $lang("payments-planned.settings.configure") }}
                          </v-btn>
                        </template>
                        <template v-slot:default="creditCardDialog">
                          <v-card class="pa-4">
                            <v-card-text class="pa-0">
                              <div class="d-flex mb-6">
                                <v-btn
                                  large
                                  icon
                                  @click="
                                    creditCardDialog.value = false;
                                    clearTemporaryChanges('creditCardForm');
                                  "
                                  class="mr-4 align-self-center"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <div class="align-self-center">
                                  <span class="text-h5 black--text">{{
                                    $lang(
                                      "booking-payment-providers.credit_card.title"
                                    )
                                  }}</span>
                                </div>
                              </div>
                              <div class="pl-4 pr-4">
                                <div
                                  class="pt-3 pb-3 pl-4 pr-4 rounded-lg d-flex align-center mb-6 grey lighten-4"
                                >
                                  <div
                                    class="text-subtitle-1 font-weight-medium mr-6"
                                  >
                                    {{
                                      $lang(
                                        "payments-planned.configuration.active_method"
                                      )
                                    }}
                                  </div>
                                  <v-switch
                                    v-model="
                                      temporaryFormsData.creditCardForm.status
                                    "
                                    color="primary"
                                    class="mt-0 pt-0"
                                    hide-details
                                    :label="
                                      temporaryFormsData.creditCardForm.status
                                        ? $lang('main.yes')
                                        : $lang('main.no')
                                    "
                                  ></v-switch>
                                </div>
                                <v-alert type="info" dense>{{
                                  $lang(
                                    "booking-payment-providers.credit_card.description"
                                  )
                                }}</v-alert>
                                <div
                                  v-if="
                                    temporaryFormsData.creditCardForm.status
                                  "
                                >
                                  <v-select
                                    multiple
                                    v-model="
                                      temporaryFormsData.creditCardForm.data
                                        .accepted_cards
                                    "
                                    :items="$in('ConstCreditCardTypes')"
                                    :label="
                                      $lang(
                                        'booking-payment-providers.accepted_cards'
                                      )
                                    "
                                    :error="!!validation.accepted_cards"
                                    :error-messages="
                                      !!validation.accepted_cards
                                        ? validation.accepted_cards
                                        : []
                                    "
                                  />
                                  <v-textarea
                                    v-model="
                                      temporaryFormsData.creditCardForm.data
                                        .terms
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.labels.terms_conditions'
                                      )
                                    "
                                    :error="!!validation.terms"
                                    :error-messages="
                                      !!validation.terms ? validation.terms : []
                                    "
                                  />
                                </div>
                              </div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-15">
                              <v-btn
                                class="mr-2"
                                @click="
                                  creditCardDialog.value = false;
                                  clearTemporaryChanges('creditCardForm');
                                "
                                >{{ $lang("main.close") }}</v-btn
                              >
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                :loading="requestLoading"
                                @click="
                                  saveData(temporaryFormsData.creditCardForm);
                                  creditCardDialog.value = false;
                                "
                              >
                                {{ $lang("main.crud.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-2">
                        <span class="text-body-2 black--text">
                          {{ $lang("payments-planned.settings.status") }}:
                        </span>
                        <v-chip
                          label
                          small
                          v-bind:class="[
                            currentFormsData.creditCardForm.status
                              ? 'green darken-1 white--text'
                              : 'grey lighten-3 black--text',
                            'font-weight-medium text-caption rounded-sm px-3'
                          ]"
                          >{{
                            currentFormsData.creditCardForm.status
                              ? $lang("payments-planned.settings.active")
                              : $lang("payments-planned.settings.inactive")
                          }}</v-chip
                        >
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text
                      v-if="
                        !!currentFormsData.creditCardForm.id &&
                        draggableForms.length > 1
                      "
                    >
                      <v-row>
                        <v-col cols="12" class="d-flex justify-end">
                          <div class="subtitle-1 mr-2">
                            {{ $lang("main.words.position") }}
                          </div>
                          <v-btn
                            v-for="(form, key) in draggableForms"
                            :color="
                              isInPosition(key, 'creditCardForm')
                                ? 'primary'
                                : ''
                            "
                            :outlined="!isInPosition(key, 'creditCardForm')"
                            @click="changePosition(key, 'creditCardForm')"
                            :key="key"
                            x-small
                            fab
                            class="mr-1"
                          >
                            {{ key + 1 }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card :disabled="isInherited">
                    <v-card-title>
                      <span class="d-flex flex-row align-center">
                        Stripe
                        <v-chip small color="primary" class="ml-3">
                          {{ $lang("booking-payment-providers.stripe.main") }}
                        </v-chip>
                      </span>
                      <v-spacer></v-spacer>
                      <v-dialog
                        max-width="900"
                        @click:outside="clearTemporaryChanges('stripeForm')"
                        @keydown.esc="clearTemporaryChanges('stripeForm')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-body-2 pt-2 pb-2 text-uppercase"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $lang("payments-planned.settings.configure") }}
                          </v-btn>
                        </template>
                        <template v-slot:default="stripeDialog">
                          <v-card class="pa-4">
                            <v-card-text class="pa-0">
                              <div class="d-flex mb-6">
                                <v-btn
                                  large
                                  icon
                                  @click="
                                    stripeDialog.value = false;
                                    clearTemporaryChanges('stripeForm');
                                  "
                                  class="mr-4 align-self-center"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <div class="align-self-center">
                                  <span class="text-h5 black--text">{{
                                    $lang(
                                      "booking-payment-providers.stripe.main"
                                    )
                                  }}</span>
                                </div>
                              </div>
                              <div class="pl-4 pr-4">
                                <div
                                  class="pt-3 pb-3 pl-4 pr-4 rounded-lg d-flex align-center mb-6 grey lighten-4"
                                >
                                  <div
                                    class="text-subtitle-1 font-weight-medium mr-6"
                                  >
                                    {{
                                      $lang(
                                        "payments-planned.configuration.active_method"
                                      )
                                    }}
                                  </div>
                                  <v-switch
                                    v-model="
                                      temporaryFormsData.stripeForm.status
                                    "
                                    color="primary"
                                    class="mt-0 pt-0"
                                    hide-details
                                    :label="
                                      temporaryFormsData.stripeForm.status
                                        ? $lang('main.yes')
                                        : $lang('main.no')
                                    "
                                  ></v-switch>
                                </div>
                                <v-card-text
                                  v-if="
                                    $can('INTERNAL_SUPPORT') &&
                                    temporaryFormsData.stripeForm.status
                                  "
                                  class="admin pl-4 pr-4 mb-6"
                                >
                                  <pre>{{
                                    currentFormsData.stripeForm.data | pretty(4)
                                  }}</pre>
                                  <v-row>
                                    <v-col cols="6">
                                      <v-select
                                        v-model="temporaryFormsData.stripeForm.data.pay_now_config"
                                        :label="$lang('booking-payment-providers.stripe.pay_now_config')"
                                        :items="[
                                          {
                                            value: 'NONE',
                                            text: $lang('booking-payment-providers.stripe.pay_now_config_options.none')
                                          },
                                          {
                                            value: 'NON_REFUNDABLE_ONLY',
                                            text: $lang('booking-payment-providers.stripe.pay_now_config_options.non_refundable_only')
                                          },
                                          {
                                            value: 'FORCE',
                                            text: $lang('booking-payment-providers.stripe.pay_now_config_options.force')
                                          },
                                        ]"
                                      />
                                    </v-col>
                                    <v-col cols="6">
                                      <v-text-field
                                        :disabled="!$role('ADMIN')"
                                        v-model="temporaryFormsData.stripeForm.data.application_fee"
                                        :label="$lang('booking-payment-providers.stripe.application_fee')"
                                        type="number"
                                        min="0"
                                        max="5"
                                        suffix="%"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                                <v-form
                                  v-if="temporaryFormsData.stripeForm.status"
                                >
                                  <v-select
                                    v-model="
                                      temporaryFormsData.stripeForm.data.variant
                                    "
                                    :items="
                                      $in('ConstBookingPaymentProviderVariants')
                                    "
                                    :label="
                                      $lang('booking-payment-providers.variant')
                                    "
                                    :error="!!validation.variant"
                                    :error-messages="
                                      !!validation.variant
                                        ? validation.variant
                                        : []
                                    "
                                  />
                                  <v-select
                                    multiple
                                    v-model="
                                      temporaryFormsData.stripeForm.data
                                        .accepted_cards
                                    "
                                    :items="$in('ConstCreditCardTypes')"
                                    :label="
                                      $lang(
                                        'booking-payment-providers.accepted_cards'
                                      )
                                    "
                                    :error="!!validation.accepted_cards"
                                    :error-messages="
                                      !!validation.accepted_cards
                                        ? validation.accepted_cards
                                        : []
                                    "
                                  />
                                  <v-textarea
                                    v-model="
                                      temporaryFormsData.stripeForm.data.terms
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.labels.terms_conditions'
                                      )
                                    "
                                    :error="!!validation.terms"
                                    :error-messages="
                                      !!validation.terms ? validation.terms : []
                                    "
                                  />
                                </v-form>
                              </div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-15">
                              <v-btn
                                class="mr-2"
                                @click="
                                  stripeDialog.value = false;
                                  clearTemporaryChanges('stripeForm');
                                "
                                >{{ $lang("main.close") }}</v-btn
                              >
                              <v-btn
                                v-if="
                                  !!currentFormsData.stripeForm.data
                                    .stripe_publishable_key
                                "
                                color="error"
                                @click="
                                  stripeDisconnect(
                                    $const(
                                      'ConstBookingPaymentProviderTypes',
                                      'STRIPE'
                                    ),
                                    true
                                  )
                                "
                              >
                                <v-icon>mdi-delete</v-icon>
                                {{
                                  $lang(
                                    "booking-payment-providers.stripe.disconnect"
                                  )
                                }}
                              </v-btn>
                              <v-btn
                                v-if="
                                  !!currentFormsData.stripeForm.data
                                    .stripe_publishable_key
                                "
                                color="warning"
                                @click="
                                  stripeDisconnect(
                                    $const(
                                      'ConstBookingPaymentProviderTypes',
                                      'STRIPE'
                                    ),
                                    false
                                  )
                                "
                              >
                                <v-icon>mdi-link-off</v-icon>
                                {{
                                  $lang(
                                    "booking-payment-providers.stripe.remove"
                                  )
                                }}
                              </v-btn>
                              <v-btn
                                color="success"
                                v-else
                                @click="
                                  stripeConnect(
                                    $const(
                                      'ConstBookingPaymentProviderTypes',
                                      'STRIPE'
                                    )
                                  )
                                "
                              >
                                <v-icon>mdi-link-plus</v-icon>
                                {{
                                  $lang(
                                    "booking-payment-providers.stripe.connect"
                                  )
                                }}
                              </v-btn>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                :loading="requestLoading"
                                :disabled="
                                  !currentFormsData.stripeForm.data
                                    .stripe_publishable_key
                                "
                                @click="
                                  saveData(temporaryFormsData.stripeForm);
                                  stripeDialog.value = false;
                                "
                              >
                                {{ $lang("main.crud.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-2">
                        <span class="text-body-2 black--text">
                          {{ $lang("payments-planned.settings.status") }}:
                        </span>
                        <v-chip
                          label
                          small
                          v-bind:class="[
                            currentFormsData.stripeForm.status
                              ? 'green darken-1 white--text'
                              : 'grey lighten-3 black--text',
                            'font-weight-medium text-caption rounded-sm px-3'
                          ]"
                          >{{
                            currentFormsData.stripeForm.status
                              ? $lang("payments-planned.settings.active")
                              : $lang("payments-planned.settings.inactive")
                          }}</v-chip
                        >
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text
                      v-if="
                        !!currentFormsData.stripeForm.id &&
                        draggableForms.length > 1
                      "
                    >
                      <v-row>
                        <v-col cols="12" class="d-flex justify-end">
                          <div class="subtitle-1 mr-2">
                            {{ $lang("main.words.position") }}
                          </div>
                          <v-btn
                            v-for="(form, key) in draggableForms"
                            :color="
                              isInPosition(key, 'stripeForm') ? 'primary' : ''
                            "
                            :outlined="!isInPosition(key, 'stripeForm')"
                            @click="changePosition(key, 'stripeForm')"
                            :key="key"
                            x-small
                            fab
                            class="mr-1"
                          >
                            {{ key + 1 }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card :disabled="isInherited">
                    <v-card-title>
                      <span class="d-flex flex-row align-center">
                        Stripe
                        <v-chip small color="primary" class="ml-3">
                          {{
                            $lang(
                              "booking-payment-providers.stripe.alternative"
                            )
                          }}
                        </v-chip>
                      </span>
                      <v-spacer></v-spacer>
                      <v-dialog
                        max-width="900"
                        @click:outside="clearTemporaryChanges('stripe2Form')"
                        @keydown.esc="clearTemporaryChanges('stripe2Form')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-body-2 pt-2 pb-2 text-uppercase"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $lang("payments-planned.settings.configure") }}
                          </v-btn>
                        </template>
                        <template v-slot:default="stripe2Dialog">
                          <v-card class="pa-4">
                            <v-card-text class="pa-0">
                              <div class="d-flex mb-6">
                                <v-btn
                                  large
                                  icon
                                  @click="
                                    stripe2Dialog.value = false;
                                    clearTemporaryChanges('stripe2Form');
                                  "
                                  class="mr-4 align-self-center"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <div class="align-self-center">
                                  <span class="text-h5 black--text">{{
                                    $lang(
                                      "booking-payment-providers.stripe.alternative"
                                    )
                                  }}</span>
                                </div>
                              </div>
                              <div class="pl-4 pr-4">
                                <div
                                  class="pt-3 pb-3 pl-4 pr-4 rounded-lg d-flex align-center mb-6 grey lighten-4"
                                >
                                  <div
                                    class="text-subtitle-1 font-weight-medium mr-6"
                                  >
                                    {{
                                      $lang(
                                        "payments-planned.configuration.active_method"
                                      )
                                    }}
                                  </div>
                                  <v-switch
                                    v-model="
                                      temporaryFormsData.stripe2Form.status
                                    "
                                    color="primary"
                                    class="mt-0 pt-0"
                                    hide-details
                                    :label="
                                      temporaryFormsData.stripe2Form.status
                                        ? $lang('main.yes')
                                        : $lang('main.no')
                                    "
                                  ></v-switch>
                                </div>
                                <v-card-text class="pa-0">
                                  <v-alert type="info">
                                    {{
                                      $lang(
                                        "booking-payment-providers.stripe.alternative_hint"
                                      )
                                    }}
                                  </v-alert>
                                </v-card-text>
                                <v-card-text
                                  v-if="
                                    $can('INTERNAL_SUPPORT') &&
                                    temporaryFormsData.stripe2Form.status
                                  "
                                  class="admin pl-4 pr-4 mb-6"
                                >
                                  <pre>{{
                                    currentFormsData.stripe2Form.data
                                      | pretty(4)
                                  }}</pre>
                                </v-card-text>
                                <v-form
                                  v-if="
                                    !!currentFormsData.stripe2Form.data
                                      .stripe_publishable_key &&
                                    temporaryFormsData.stripe2Form.status
                                  "
                                >
                                  <v-select
                                    v-model="
                                      temporaryFormsData.stripe2Form.data
                                        .variant
                                    "
                                    :items="
                                      $in('ConstBookingPaymentProviderVariants')
                                    "
                                    :label="
                                      $lang('booking-payment-providers.variant')
                                    "
                                    :error="!!validation.variant"
                                    :error-messages="
                                      !!validation.variant
                                        ? validation.variant
                                        : []
                                    "
                                  />
                                  <v-select
                                    multiple
                                    v-model="
                                      temporaryFormsData.stripe2Form.data
                                        .accepted_cards
                                    "
                                    :items="$in('ConstCreditCardTypes')"
                                    :label="
                                      $lang(
                                        'booking-payment-providers.accepted_cards'
                                      )
                                    "
                                    :error="!!validation.accepted_cards"
                                    :error-messages="
                                      !!validation.accepted_cards
                                        ? validation.accepted_cards
                                        : []
                                    "
                                  />
                                  <v-textarea
                                    v-model="
                                      temporaryFormsData.stripe2Form.data.terms
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.labels.terms_conditions'
                                      )
                                    "
                                    :error="!!validation.terms"
                                    :error-messages="
                                      !!validation.terms ? validation.terms : []
                                    "
                                  />
                                </v-form>
                              </div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-15">
                              <v-btn
                                class="mr-2"
                                @click="
                                  stripe2Dialog.value = false;
                                  clearTemporaryChanges('stripe2Form');
                                "
                                >{{ $lang("main.close") }}</v-btn
                              >
                              <v-btn
                                v-if="
                                  !!currentFormsData.stripe2Form.data
                                    .stripe_publishable_key
                                "
                                color="error"
                                @click="
                                  stripeDisconnect(
                                    $const(
                                      'ConstBookingPaymentProviderTypes',
                                      'STRIPE_2'
                                    ),
                                    true
                                  )
                                "
                              >
                                <v-icon>mdi-delete</v-icon>
                                {{
                                  $lang(
                                    "booking-payment-providers.stripe.disconnect"
                                  )
                                }}
                              </v-btn>
                              <v-btn
                                v-if="
                                  !!currentFormsData.stripeForm.data
                                    .stripe_publishable_key
                                "
                                color="warning"
                                @click="
                                  stripeDisconnect(
                                    $const(
                                      'ConstBookingPaymentProviderTypes',
                                      'STRIPE_2'
                                    ),
                                    false
                                  )
                                "
                              >
                                <v-icon>mdi-link-off</v-icon>
                                {{
                                  $lang(
                                    "booking-payment-providers.stripe.remove"
                                  )
                                }}
                              </v-btn>
                              <v-btn
                                color="success"
                                v-else
                                @click="
                                  stripeConnect(
                                    $const(
                                      'ConstBookingPaymentProviderTypes',
                                      'STRIPE_2'
                                    )
                                  )
                                "
                              >
                                <v-icon>mdi-link-plus</v-icon>
                                {{
                                  $lang(
                                    "booking-payment-providers.stripe.connect"
                                  )
                                }}
                              </v-btn>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                :loading="requestLoading"
                                :disabled="
                                  !currentFormsData.stripe2Form.data
                                    .stripe_publishable_key
                                "
                                @click="
                                  saveData(temporaryFormsData.stripe2Form);
                                  stripe2Dialog.value = false;
                                "
                              >
                                {{ $lang("main.crud.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-2">
                        <span class="text-body-2 black--text">
                          {{ $lang("payments-planned.settings.status") }}:
                        </span>
                        <v-chip
                          label
                          small
                          v-bind:class="[
                            currentFormsData.stripe2Form.status
                              ? 'green darken-1 white--text'
                              : 'grey lighten-3 black--text',
                            'font-weight-medium text-caption rounded-sm px-3'
                          ]"
                          >{{
                            currentFormsData.stripe2Form.status
                              ? $lang("payments-planned.settings.active")
                              : $lang("payments-planned.settings.inactive")
                          }}</v-chip
                        >
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text
                      v-if="
                        !!currentFormsData.stripe2Form.id &&
                        draggableForms.length > 1
                      "
                    >
                      <v-row>
                        <v-col cols="12" class="d-flex justify-end">
                          <div class="subtitle-1 mr-2">
                            {{ $lang("main.words.position") }}
                          </div>
                          <v-btn
                            v-for="(form, key) in draggableForms"
                            :color="
                              isInPosition(key, 'stripe2Form') ? 'primary' : ''
                            "
                            :outlined="!isInPosition(key, 'stripe2Form')"
                            @click="changePosition(key, 'stripe2Form')"
                            :key="key"
                            x-small
                            fab
                            class="mr-1"
                          >
                            {{ key + 1 }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card :disabled="isInherited">
                    <v-card-title>
                      <span class="text-h6">
                        {{
                          $lang("booking-payment-providers.bank_transfer.title")
                        }}
                      </span>
                      <v-spacer></v-spacer>
                      <v-dialog
                        max-width="900"
                        @click:outside="clearTemporaryChanges('transferForm')"
                        @keydown.esc="clearTemporaryChanges('transferForm')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-body-2 pt-2 pb-2 text-uppercase"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $lang("payments-planned.settings.configure") }}
                          </v-btn>
                        </template>
                        <template v-slot:default="transferDialog">
                          <v-card class="pa-4">
                            <v-card-text class="pa-0">
                              <div class="d-flex mb-6">
                                <v-btn
                                  large
                                  icon
                                  @click="
                                    transferDialog.value = false;
                                    clearTemporaryChanges('transferForm');
                                  "
                                  class="mr-4 align-self-center"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <div class="align-self-center">
                                  <span class="text-h5 black--text">{{
                                    $lang(
                                      "booking-payment-providers.bank_transfer.title"
                                    )
                                  }}</span>
                                </div>
                              </div>
                              <div class="pl-4 pr-4">
                                <div
                                  class="pt-3 pb-3 pl-4 pr-4 rounded-lg d-flex align-center mb-6 grey lighten-4"
                                >
                                  <div
                                    class="text-subtitle-1 font-weight-medium mr-6"
                                  >
                                    {{
                                      $lang(
                                        "payments-planned.configuration.active_method"
                                      )
                                    }}
                                  </div>
                                  <v-switch
                                    v-model="
                                      temporaryFormsData.transferForm.status
                                    "
                                    color="primary"
                                    class="mt-0 pt-0"
                                    hide-details
                                    :label="
                                      temporaryFormsData.transferForm.status
                                        ? $lang('main.yes')
                                        : $lang('main.no')
                                    "
                                  ></v-switch>
                                </div>
                                <v-form
                                  v-if="temporaryFormsData.transferForm.status"
                                >
                                  <v-text-field
                                    v-model="
                                      temporaryFormsData.transferForm.data
                                        .account_holder
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.account_holder'
                                      )
                                    "
                                    :error="!!validation.account_holder"
                                    :error-messages="
                                      !!validation.account_holder
                                        ? validation.account_holder
                                        : []
                                    "
                                  />
                                  <v-text-field
                                    v-model="
                                      temporaryFormsData.transferForm.data
                                        .bank_name
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.bank_name'
                                      )
                                    "
                                    :error="!!validation.bank_name"
                                    :error-messages="
                                      !!validation.bank_name
                                        ? validation.bank_name
                                        : []
                                    "
                                  />
                                  <v-text-field
                                    v-model="
                                      temporaryFormsData.transferForm.data.iban
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.iban'
                                      )
                                    "
                                    :error="!!validation.iban"
                                    :error-messages="
                                      !!validation.iban ? validation.iban : []
                                    "
                                  />
                                  <v-text-field
                                    v-model="
                                      temporaryFormsData.transferForm.data.swift
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.bic_swift'
                                      )
                                    "
                                    :error="!!validation.swift"
                                    :error-messages="
                                      !!validation.swift ? validation.swift : []
                                    "
                                  />
                                  <v-text-field
                                    v-model="
                                      temporaryFormsData.transferForm.data
                                        .advance_days
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.advance_days'
                                      )
                                    "
                                    :hint="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.hints.advance_days',
                                        {
                                          days:
                                            temporaryFormsData.transferForm.data
                                              .advance_days || 'x'
                                        }
                                      )
                                    "
                                    :error="!!validation.advance_days"
                                    :error-messages="
                                      !!validation.advance_days
                                        ? validation.advance_days
                                        : []
                                    "
                                  />
                                  <v-switch
                                    :label="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.is_only_not_refundable'
                                      )
                                    "
                                    :hint="
                                      $lang(
                                        'booking-payment-providers.bank_transfer.hints.is_only_not_refundable'
                                      )
                                    "
                                    persistent-hint
                                    v-model="
                                      temporaryFormsData.transferForm.data
                                        .is_only_not_refundable
                                    "
                                  />
                                  <v-textarea
                                    v-model="
                                      temporaryFormsData.transferForm.data.terms
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.labels.terms_conditions'
                                      )
                                    "
                                    :error="!!validation.terms"
                                    :error-messages="
                                      !!validation.terms ? validation.terms : []
                                    "
                                  />
                                </v-form>
                              </div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-15">
                              <v-btn
                                class="mr-2"
                                @click="
                                  transferDialog.value = false;
                                  clearTemporaryChanges('transferForm');
                                "
                                >{{ $lang("main.close") }}</v-btn
                              >
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                :loading="requestLoading"
                                @click="
                                  saveData(temporaryFormsData.transferForm);
                                  transferDialog.value = false;
                                "
                              >
                                {{ $lang("main.crud.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-2">
                        <span class="text-body-2 black--text">
                          {{ $lang("payments-planned.settings.status") }}:
                        </span>
                        <v-chip
                          label
                          small
                          v-bind:class="[
                            currentFormsData.transferForm.status
                              ? 'green darken-1 white--text'
                              : 'grey lighten-3 black--text',
                            'font-weight-medium text-caption rounded-sm px-3'
                          ]"
                          >{{
                            currentFormsData.transferForm.status
                              ? $lang("payments-planned.settings.active")
                              : $lang("payments-planned.settings.inactive")
                          }}</v-chip
                        >
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text
                      v-if="
                        !!currentFormsData.transferForm.id &&
                        draggableForms.length > 1
                      "
                    >
                      <v-row>
                        <v-col cols="12" class="d-flex justify-end">
                          <div class="subtitle-1 mr-2">
                            {{ $lang("main.words.position") }}
                          </div>
                          <v-btn
                            v-for="(form, key) in draggableForms"
                            :color="
                              isInPosition(key, 'transferForm') ? 'primary' : ''
                            "
                            :outlined="!isInPosition(key, 'transferForm')"
                            @click="changePosition(key, 'transferForm')"
                            :key="key"
                            x-small
                            fab
                            class="mr-1"
                          >
                            {{ key + 1 }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12">
                  <v-card :disabled="isInherited">
                    <v-card-title>
                      <span class="text-h6">
                        {{ $lang("booking-payment-providers.cash.title") }}
                      </span>
                      <v-spacer></v-spacer>
                      <v-dialog
                        max-width="900"
                        @click:outside="clearTemporaryChanges('cashForm')"
                        @keydown.esc="clearTemporaryChanges('cashForm')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-body-2 pt-2 pb-2 text-uppercase"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $lang("payments-planned.settings.configure") }}
                          </v-btn>
                        </template>
                        <template v-slot:default="cashDialog">
                          <v-card class="pa-4">
                            <v-card-text class="pa-0">
                              <div class="d-flex mb-6">
                                <v-btn
                                  large
                                  icon
                                  @click="
                                    cashDialog.value = false;
                                    clearTemporaryChanges('cashForm');
                                  "
                                  class="mr-4 align-self-center"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <div class="align-self-center">
                                  <span class="text-h5 black--text">{{
                                    $lang(
                                      "booking-payment-providers.cash.title"
                                    )
                                  }}</span>
                                </div>
                              </div>
                              <div class="pl-4 pr-4">
                                <div
                                  class="pt-3 pb-3 pl-4 pr-4 rounded-lg d-flex align-center mb-6 grey lighten-4"
                                >
                                  <div
                                    class="text-subtitle-1 font-weight-medium mr-6"
                                  >
                                    {{
                                      $lang(
                                        "payments-planned.configuration.active_method"
                                      )
                                    }}
                                  </div>
                                  <v-switch
                                    v-model="temporaryFormsData.cashForm.status"
                                    color="primary"
                                    class="mt-0 pt-0"
                                    hide-details
                                    :label="
                                      temporaryFormsData.cashForm.status
                                        ? $lang('main.yes')
                                        : $lang('main.no')
                                    "
                                  ></v-switch>
                                </div>
                                <v-form
                                  v-if="temporaryFormsData.cashForm.status"
                                >
                                  <v-switch
                                    :label="
                                      $lang(
                                        'booking-payment-providers.cash.mobile_only'
                                      )
                                    "
                                    v-model="
                                      temporaryFormsData.cashForm.data
                                        .mobile_only
                                    "
                                  />
                                  <v-text-field
                                    type="number"
                                    step="1"
                                    min="1"
                                    v-model="
                                      temporaryFormsData.cashForm.data
                                        .days_advance
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.cash.days_advance'
                                      )
                                    "
                                    :hint="
                                      $lang(
                                        'booking-payment-providers.cash.hints.days_advance',
                                        {
                                          days:
                                            temporaryFormsData.cashForm.data
                                              .days_advance || 'x'
                                        }
                                      )
                                    "
                                    :error="!!validation.days_advance"
                                    :error-messages="
                                      !!validation.days_advance
                                        ? validation.days_advance
                                        : []
                                    "
                                  />
                                  <v-textarea
                                    v-model="
                                      temporaryFormsData.cashForm.data.terms
                                    "
                                    :label="
                                      $lang(
                                        'booking-payment-providers.labels.terms_conditions'
                                      )
                                    "
                                    :error="!!validation.terms"
                                    :error-messages="
                                      !!validation.terms ? validation.terms : []
                                    "
                                  />
                                </v-form>
                              </div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-15">
                              <v-btn
                                class="mr-2"
                                @click="
                                  cashDialog.value = false;
                                  clearTemporaryChanges('cashForm');
                                "
                                >{{ $lang("main.close") }}</v-btn
                              >
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                :loading="requestLoading"
                                @click="
                                  saveData(temporaryFormsData.cashForm);
                                  cashDialog.value = false;
                                "
                              >
                                {{ $lang("main.crud.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-2">
                        <span class="text-body-2 black--text">
                          {{ $lang("payments-planned.settings.status") }}:
                        </span>
                        <v-chip
                          label
                          small
                          v-bind:class="[
                            currentFormsData.cashForm.status
                              ? 'green darken-1 white--text'
                              : 'grey lighten-3 black--text',
                            'font-weight-medium text-caption rounded-sm px-3'
                          ]"
                          >{{
                            currentFormsData.cashForm.status
                              ? $lang("payments-planned.settings.active")
                              : $lang("payments-planned.settings.inactive")
                          }}</v-chip
                        >
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text
                      v-if="
                        !!currentFormsData.cashForm.id &&
                        draggableForms.length > 1
                      "
                    >
                      <v-row>
                        <v-col cols="6">
                          <div class="subtitle-1 mr-2">
                            {{ $lang("main.words.position") }}:
                          </div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <v-btn
                            v-for="(form, key) in draggableForms"
                            :color="
                              isInPosition(key, 'cashForm') ? 'primary' : ''
                            "
                            :outlined="!isInPosition(key, 'cashForm')"
                            @click="changePosition(key, 'cashForm')"
                            :key="key"
                            x-small
                            fab
                            class="mr-1"
                          >
                            {{ key + 1 }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="12" v-if="$can('ADVANCED_FEATURE')">
                  <v-card :disabled="isInherited">
                    <v-card-title>
                      <span class="text-h6"> Nexi </span>
                      <v-spacer></v-spacer>
                      <v-dialog
                        max-width="900"
                        @click:outside="clearTemporaryChanges('nexiForm')"
                        @keydown.esc="clearTemporaryChanges('nexiForm')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="text-body-2 pt-2 pb-2 text-uppercase"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $lang("payments-planned.settings.configure") }}
                          </v-btn>
                        </template>
                        <template v-slot:default="nexiDialog">
                          <v-card class="pa-4">
                            <v-card-text class="pa-0">
                              <div class="d-flex mb-6">
                                <v-btn
                                  large
                                  icon
                                  @click="
                                    nexiDialog.value = false;
                                    clearTemporaryChanges('nexiForm');
                                  "
                                  class="mr-4 align-self-center"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <div class="align-self-center">
                                  <span class="text-h5 black--text">Nexi</span>
                                </div>
                              </div>
                              <div class="pl-4 pr-4">
                                <div
                                  class="pt-3 pb-3 pl-4 pr-4 rounded-lg d-flex align-center mb-6 grey lighten-4"
                                >
                                  <div
                                    class="text-subtitle-1 font-weight-medium mr-6"
                                  >
                                    {{
                                      $lang(
                                        "payments-planned.configuration.active_method"
                                      )
                                    }}
                                  </div>
                                  <v-switch
                                    v-model="temporaryFormsData.nexiForm.status"
                                    color="primary"
                                    class="mt-0 pt-0"
                                    hide-details
                                    :label="
                                      temporaryFormsData.nexiForm.status
                                        ? $lang('main.yes')
                                        : $lang('main.no')
                                    "
                                  ></v-switch>
                                </div>
                                <v-alert type="info" dense>{{
                                  $lang(
                                    "booking-payment-providers.nexi.subtitle"
                                  )
                                }}</v-alert>
                                <div v-if="temporaryFormsData.nexiForm.status">
                                  <v-form>
                                    <v-text-field
                                      v-model="
                                        temporaryFormsData.nexiForm.data.alias
                                      "
                                      :label="
                                        $lang(
                                          'booking-payment-providers.nexi.alias'
                                        )
                                      "
                                      :error="!!validation.alias"
                                      :error-messages="
                                        !!validation.alias
                                          ? validation.alias
                                          : []
                                      "
                                    />
                                    <v-text-field
                                      v-model="
                                        temporaryFormsData.nexiForm.data.mac
                                      "
                                      :label="
                                        $lang(
                                          'booking-payment-providers.nexi.mac'
                                        )
                                      "
                                      :error="!!validation.mac"
                                      :error-messages="
                                        !!validation.mac ? validation.mac : []
                                      "
                                    />
                                    <v-select
                                      v-model="
                                        temporaryFormsData.nexiForm.data.variant
                                      "
                                      :items="
                                        $in(
                                          'ConstBookingPaymentProviderVariants'
                                        )
                                      "
                                      :label="
                                        $lang(
                                          'booking-payment-providers.variant'
                                        )
                                      "
                                      :error="!!validation.variant"
                                      :error-messages="
                                        !!validation.variant
                                          ? validation.variant
                                          : []
                                      "
                                    />
                                    <v-select
                                      multiple
                                      v-model="
                                        temporaryFormsData.nexiForm.data
                                          .accepted_cards
                                      "
                                      :items="$in('ConstCreditCardTypes')"
                                      :label="
                                        $lang(
                                          'booking-payment-providers.accepted_cards'
                                        )
                                      "
                                      :error="!!validation.accepted_cards"
                                      :error-messages="
                                        !!validation.accepted_cards
                                          ? validation.accepted_cards
                                          : []
                                      "
                                    />
                                    <v-textarea
                                      v-model="
                                        temporaryFormsData.nexiForm.data.terms
                                      "
                                      :label="
                                        $lang(
                                          'booking-payment-providers.labels.terms_conditions'
                                        )
                                      "
                                      :error="!!validation.terms"
                                      :error-messages="
                                        !!validation.terms
                                          ? validation.terms
                                          : []
                                      "
                                    />
                                    <v-alert
                                      v-if="
                                        temporaryFormsData.nexiForm.data
                                          .variant ===
                                        $const(
                                          'ConstBookingPaymentProviderVariants',
                                          'NO_SCA'
                                        )
                                      "
                                      v-html="
                                        $lang(
                                          'booking-payment-providers.nexi.moto_hint'
                                        )
                                      "
                                      type="warning"
                                    />
                                  </v-form>
                                </div>
                              </div>
                            </v-card-text>
                            <v-card-actions class="pa-0 mt-15">
                              <v-btn
                                class="mr-2"
                                @click="
                                  nexiDialog.value = false;
                                  clearTemporaryChanges('nexiForm');
                                "
                                >{{ $lang("main.close") }}</v-btn
                              >
                              <v-spacer></v-spacer>
                              <v-btn
                                color="success"
                                :loading="requestLoading"
                                @click="
                                  saveData(temporaryFormsData.nexiForm);
                                  nexiDialog.value = false;
                                "
                              >
                                {{ $lang("main.crud.save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </v-card-title>
                    <v-card-text>
                      <div class="mt-2">
                        <span class="text-body-2 black--text">
                          {{ $lang("payments-planned.settings.status") }}:
                        </span>
                        <v-chip
                          label
                          small
                          v-bind:class="[
                            currentFormsData.nexiForm.status
                              ? 'green darken-1 white--text'
                              : 'grey lighten-3 black--text',
                            'font-weight-medium text-caption rounded-sm px-3'
                          ]"
                          >{{
                            currentFormsData.nexiForm.status
                              ? $lang("payments-planned.settings.active")
                              : $lang("payments-planned.settings.inactive")
                          }}</v-chip
                        >
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text
                      v-if="
                        !!currentFormsData.nexiForm.id &&
                        draggableForms.length > 1
                      "
                    >
                      <v-row>
                        <v-col cols="6">
                          <div class="subtitle-1 mr-2">
                            {{ $lang("main.words.position") }}:
                          </div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <v-btn
                            v-for="(form, key) in draggableForms"
                            :color="
                              isInPosition(key, 'nexiForm') ? 'primary' : ''
                            "
                            :outlined="!isInPosition(key, 'nexiForm')"
                            @click="changePosition(key, 'nexiForm')"
                            :key="key"
                            x-small
                            fab
                            class="mr-1"
                          >
                            {{ key + 1 }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" md="4">
            <v-card>
              <v-card-title>{{
                $lang("booking-payment-providers.helps.companies.title")
              }}</v-card-title>
              <v-card-text
                v-html="$lang('booking-payment-providers.helps.companies.text')"
              >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-confirmation
      v-model="showStripeAuthModal"
      :options="{
        yes: () => stripeAction(),
        loading: stripeLoading
      }"
    />
    <v-confirmation
      v-model="isOpenInherit"
      :options="{
        yes: () => confirmInheritAction()
      }"
    />
  </v-card>
</template>

<script>
import { mapState } from "vuex";

import data from "@/mixins/data";
import formable from "@/mixins/formable";

import {
  CREATE_BOOKING_PAYMENT_PROVIDERS,
  GET_BOOKING_PAYMENT_PROVIDERS_COLLECTION,
  GET_BOOKING_PAYMENT_STRIPE_AUTH_URL,
  INHERIT_BOOKING_PAYMENT_PROVIDERS,
  OVERRIDE_BOOKING_PAYMENT_PROVIDERS,
  REMOVE_BOOKING_PAYMENT_STRIPE_AUTH,
  UPDATE_BOOKING_PAYMENT_PROVIDERS,
  UPDATE_BOOKING_PAYMENT_PROVIDERS_RESET,
  POSITION_BOOKING_PAYMENT_PROVIDERS,
  UPDATE_PAYMENT_AUTOMATION_BOOKING_PAYMENT_PROVIDER_CONFIGURATION
} from "@/store/booking-payment-providers/actions";

import SessionService from "@/libraries/sessionjs/src";

import defaultPaymentProcessors from "./Interfaces/defaults.js";
import connect from "./mixins/connect.js";
import {
  GET_BOOKING_PAYMENT_PROVIDERS_SINGLE,
  INHERIT_PAYMENT_AUTOMATION_BOOKING_PAYMENT_PROVIDER_CONFIGURATION
} from "../../store/booking-payment-providers/actions.js";
import { cloneDeep } from "lodash";

import Vue from "vue";

export default {
  name: "BookingPaymentProvidersForm",
  mixins: [data, formable, connect],
  props: {
    isInherit: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    ownerType: {
      required: true
    }
  },
  data() {
    return {
      panel: 0,
      lang: "en",
      isInherited: false,
      isOpenInherit: false,
      isLoadingPaymentAutomationConfig: false,
      inheritAction: null,
      showStripeAuthModal: false,
      stripeActionType: null,
      stripeRemove: false,
      activeType: null,
      allForms: [
        "paymentAutomationForm",
        "stripeForm",
        "stripe2Form",
        "transferForm",
        "cashForm",
        "nexiForm",
        "creditCardForm"
      ],
      currentFormsData: cloneDeep(defaultPaymentProcessors),
      temporaryFormsData: cloneDeep(defaultPaymentProcessors)
    };
  },
  created() {
    this.setTypes();
    this.findData();
  },
  methods: {
    setTypes() {
      this.currentFormsData.stripeForm.type =
        this.temporaryFormsData.stripeForm.type = this.$const(
          "ConstBookingPaymentProviderTypes",
          "STRIPE"
        );
      this.currentFormsData.stripe2Form.type =
        this.temporaryFormsData.stripe2Form.type = this.$const(
          "ConstBookingPaymentProviderTypes",
          "STRIPE_2"
        );
      this.currentFormsData.transferForm.type =
        this.temporaryFormsData.transferForm.type = this.$const(
          "ConstBookingPaymentProviderTypes",
          "BANK_TRANSFER"
        );
      this.currentFormsData.cashForm.type =
        this.temporaryFormsData.cashForm.type = this.$const(
          "ConstBookingPaymentProviderTypes",
          "CASH"
        );
      this.currentFormsData.nexiForm.type =
        this.temporaryFormsData.nexiForm.type = this.$const(
          "ConstBookingPaymentProviderTypes",
          "NEXI"
        );
      this.currentFormsData.creditCardForm.type =
        this.temporaryFormsData.creditCardForm.type = this.$const(
          "ConstBookingPaymentProviderTypes",
          "CREDIT_CARD"
        );
      this.currentFormsData.paymentAutomationForm.type =
        this.temporaryFormsData.paymentAutomationForm.type = this.$const(
          "ConstBookingPaymentProviderTypes",
          "PAYMENT_AUTOMATION"
        );
    },
    openInherit(key) {
      this.inheritAction = key;
      this.isOpenInherit = true;
    },
    async confirmInheritAction() {
      await this[this.inheritAction]();
      await this.$store.dispatch(
        INHERIT_PAYMENT_AUTOMATION_BOOKING_PAYMENT_PROVIDER_CONFIGURATION,
        { id: this.$route.params.id }
      );
      this.isOpenInherit = false;
      this.inheritAction = null;
    },
    async override() {
      await this.$store.dispatch(OVERRIDE_BOOKING_PAYMENT_PROVIDERS, {
        property_id: this.$route.params.id
      });
      this.resetScope();
      this.setTypes();
    },
    async inherit() {
      await this.$store.dispatch(INHERIT_BOOKING_PAYMENT_PROVIDERS, {
        property_id: this.$route.params.id
      });
      this.findData();
    },
    findData() {
      const params = {
        _data: {
          sortBy: "position",
          order: "asc"
        }
      };

      if (this.ownerType === this.$const("ConstMorphTypeAliases", "COMPANY")) {
        params.company_id = this.$route.params.id;
      }
      if (this.ownerType === this.$const("ConstMorphTypeAliases", "PROPERTY")) {
        params.property_id = this.$route.params.id;
      }

      this.$store
        .dispatch(GET_BOOKING_PAYMENT_PROVIDERS_COLLECTION, params)
        .then(({ collection }) => {
          for (const item of collection) {
            this.allForms.map((form) => {
              if (this.currentFormsData[form].type === item.type) {
                const data = this.currentFormsData[form].data;

                this.currentFormsData[form] = {
                  ...this.currentFormsData[form],
                  ...item
                };

                this.currentFormsData[form].data = {
                  ...data,
                  ...item.data
                };

                this.temporaryFormsData[form] = cloneDeep(
                  this.currentFormsData[form]
                );

                if (
                  item.owner_type ==
                    this.$const("ConstMorphTypeAliases", "COMPANY") &&
                  this.ownerType ==
                    this.$const("ConstMorphTypeAliases", "PROPERTY")
                ) {
                  this.isInherited = true;
                }
              }
            });
          }
        });
    },
    success(response) {
      this.findData();
    },
    stripeConnect(type) {
      this.activeType = type;
      this.stripeActionType = "stripeLogin";
      this.showStripeAuthModal = true;
    },
    stripeDisconnect(type, remove) {
      this.activeType = type;
      this.stripeActionType = "stripeLogout";
      this.showStripeAuthModal = true;
      this.stripeRemove = remove;
    },
    async stripeAction() {
      await this[this.stripeActionType]();
      this.stripeActionType = null;
    },
    async stripeLogin() {
      const data = {
        owner_type: this.ownerType,
        owner_id: this.$route.params.id,
        type: this.activeType
      };
      const url = await this.$store.dispatch(
        GET_BOOKING_PAYMENT_STRIPE_AUTH_URL,
        data
      );
      SessionService.set("pp_data", data, {
        path: "/",
        expires: new Date(this.$moment().add(1, "years").format("YYYY-MM-DD"))
      });
      window.location.href = url;
    },
    stripeLogout() {
      this.$store
        .dispatch(REMOVE_BOOKING_PAYMENT_STRIPE_AUTH, {
          owner_type: this.ownerType,
          owner_id: this.$route.params.id,
          type: this.activeType,
          remove: this.stripeRemove
        })
        .then((reponse) => {
          this.showStripeAuthModal = false;
          this.currentFormsData.stripeForm = this.temporaryFormsData.stripForm =
            defaultPaymentProcessors.stripeForm;
        })
        .catch((error) => {
          this.showNotification(
            this.$lang("main.crud.something_went_wrong"),
            "error"
          );
          this.showStripeAuthModal = false;
          this.findData();
        });
    },
    saveData(form) {
      form["owner_id"] = this.$route.params.id;
      form["owner_type"] = this.ownerType;
      this.form = form;

      this.submit().then((response) => {
        this.findData();
      });
    },
    populate(item) {
      this.form = {
        ...this.form,
        ...item
      };
    },
    resetAction() {
      return UPDATE_BOOKING_PAYMENT_PROVIDERS_RESET;
    },
    submitAction() {
      return !!this.form.id
        ? UPDATE_BOOKING_PAYMENT_PROVIDERS
        : CREATE_BOOKING_PAYMENT_PROVIDERS;
    },
    submitActionOptions() {
      if (!!this.form.id) {
        return {
          id: this.form.id,
          params: this.form
        };
      }
      return this.form;
    },
    clearTemporaryChanges(form) {
      this.temporaryFormsData[form] = cloneDeep(this.currentFormsData[form]);
    },
    changePosition(place, form) {
      const allPlaces = this.getAllPositions();
      const newForm = allPlaces.filter((item) => item.place === place)[0].form;

      this.$store
        .dispatch(POSITION_BOOKING_PAYMENT_PROVIDERS, {
          id: this.currentFormsData[form].id,
          old: this.currentFormsData[form],
          new: this.temporaryFormsData[newForm]
        })
        .then(() => {
          this.findData();
        })
        .catch(() => {
          this.findData();
        });
    },
    isInPosition(place, form) {
      return this.getPosition(form) === place;
    },
    getPosition(form) {
      let place = 0;

      this.draggableForms.forEach((_form) => {
        if (
          this.currentFormsData[_form].position <
          this.currentFormsData[form].position
        ) {
          place++;
        }
      });

      return place;
    },
    getAllPositions() {
      let places = [];

      this.draggableForms.forEach((form) => {
        places.push({ form, place: this.getPosition(form) });
      });

      return places;
    },
    async initStripeConnect() {
      await this.initStripeConnectInstance(
        this.ownerType === this.$const("ConstMorphTypeAliases", "COMPANY")
          ? this.company
          : this.property
      );
    },
    async mountStripeConnectOnboardingSessionElement() {
      const paymentAutomationConfig = this.collection.find(
        (bookingPaymentProvider) =>
          bookingPaymentProvider.type ===
          this.$const("ConstBookingPaymentProviderTypes", "PAYMENT_AUTOMATION")
      );

      if (
        !this.connectInstance &&
        !this.isLoadingStripeConnectInstance &&
        !paymentAutomationConfig
      ) {
        await this.initStripeConnect();
      }

      if (
        !this.connectOnboardingSession &&
        !this.isLoadingStripeConnectOnboardingSession &&
        !paymentAutomationConfig
      ) {
        const isCompany =
          this.ownerType === this.$const("ConstMorphTypeAliases", "COMPANY");
        const isProperty =
          this.ownerType === this.$const("ConstMorphTypeAliases", "PROPERTY");

        await this.createStripeConnectOnboardingSession(
          isCompany ? 2 : isProperty ? 3 : null,
          this.$route.params.id,
          isCompany
            ? this.company.id
            : isProperty
            ? this.property.company_id
            : undefined,
          isCompany ? undefined : isProperty ? this.property.id : null
        );

        this.$nextTick(() => {
          const container = document.getElementById(
            "embedded-onboarding-container"
          );
          if (!container?.childElementCount) {
            container.appendChild(this.connectOnboardingSession);
          }
        });
      } else {
        if (paymentAutomationConfig) {
          this.isLoadingPaymentAutomationConfig = true;
          const res = await this.$store.dispatch(
            GET_BOOKING_PAYMENT_PROVIDERS_SINGLE,
            {
              id: paymentAutomationConfig.id
            }
          );
          const resData = JSON.parse(res.data);
          const resObject = {
            ...this.currentFormsData["paymentAutomationForm"],
            status: res.status,
            data: {
              configuration_id: resData.id || null,
              excluded_reservation_sources:
                resData.accountConfig.excludedReservationSources || [],
              immediately_send_payment_request:
                resData.accountConfig.sendPaymentRequestOnBookingConfirmation ||
                false
            }
          };
          this.currentFormsData["paymentAutomationForm"] = cloneDeep(resObject);
          this.temporaryFormsData["paymentAutomationForm"] =
            cloneDeep(resObject);

          this.connectAccountId = resData.paymentConfig.stripeAccountId;
          this.isLoadingPaymentAutomationConfig = false;
        }
      }
    },
    async updatePaymentAutomationConfiguration() {
      await this.$store.dispatch(
        UPDATE_PAYMENT_AUTOMATION_BOOKING_PAYMENT_PROVIDER_CONFIGURATION,
        {
          ownerType:
            this.ownerType === this.$const("ConstMorphTypeAliases", "COMPANY")
              ? 2
              : this.ownerType ===
                this.$const("ConstMorphTypeAliases", "PROPERTY")
              ? 3
              : null,
          ownerId: Number(this.$route.params.id),
          isActive: this.temporaryFormsData.paymentAutomationForm.status,
          paymentConfig: {
            stripeAccountId: this.connectAccountId
          },
          accountConfig: {
            excludeVirtualCard: true,
            excludedReservationSources: this.temporaryFormsData
              .paymentAutomationForm.status
              ? [
                  ...new Set([
                    5,
                    ...this.temporaryFormsData.paymentAutomationForm.data
                      .excluded_reservation_sources
                  ])
                ]
              : [5],
            sendPaymentRequestOnBookingConfirmation: this.temporaryFormsData
              .paymentAutomationForm.status
              ? this.temporaryFormsData.paymentAutomationForm.data
                  .immediately_send_payment_request
              : false
          }
        }
      );

      this.currentFormsData["paymentAutomationForm"] = cloneDeep(
        this.temporaryFormsData["paymentAutomationForm"]
      );
    }
  },
  computed: {
    draggableForms() {
      return this.allForms.filter((form) => !!this.currentFormsData[form].id);
    },
    requestLoading() {
      return this.createRequest.loading || this.editingRequest.loading;
    },
    isShowPropertyWarning() {
      return (
        this.ownerType === this.$const("ConstMorphTypeAliases", "PROPERTY")
      );
    },
    ...mapState({
      createRequest: (state) => state.bookingPaymentProviders.creationRequest,
      editingRequest: (state) => state.bookingPaymentProviders.editingRequest,
      item: (state) => state.bookingPaymentProviders.getSingleRequest.item,
      collection: (state) =>
        state.bookingPaymentProviders.getCollectionRequest.collection,
      loading: (state) => state.bookingPaymentProviders.editingRequest.loading,
      validation: (state) =>
        state.bookingPaymentProviders.editingRequest.validation,
      stripeLoading: (state) => state.bookingPaymentProviders.stripe.loading,
      company: (state) => state.companies.getSingleRequest.item,
      property: (state) => state.properties.getSingleRequest.item
    }),
    reactiveDefaultPaymentProcessors() {
      return Vue.observable(defaultPaymentProcessors);
    }
  },
  filters: {
    pretty: (val, indent = 2) => {
      if (typeof val === "string") {
        val = JSON.parse(val);
      }
      return JSON.stringify(val, null, indent);
    }
  },
  watch: {
    "temporaryFormsData.cashForm.status"(newVal, oldVal) {
      if (!newVal && oldVal && !!this.currentFormsData.cashForm.id) {
        this.saveData(this.temporaryFormsData.cashForm);
      }
    },
    "temporaryFormsData.transferForm.status"(newVal, oldVal) {
      if (!newVal && oldVal && !!this.currentFormsData.transferForm.id) {
        this.saveData(this.temporaryFormsData.transferForm);
      }
    },
    "temporaryFormsData.stripeForm.status"(newVal, oldVal) {
      if (!newVal && oldVal && !!this.currentFormsData.stripeForm.id) {
        this.saveData(this.temporaryFormsData.stripeForm);
      }
    },
    "temporaryFormsData.stripe2Form.status"(newVal, oldVal) {
      if (!newVal && oldVal && !!this.currentFormsData.stripe2Form.id) {
        this.saveData(this.temporaryFormsData.stripe2Form);
      }
    },
    "temporaryFormsData.nexiForm.status"(newVal, oldVal) {
      if (!newVal && oldVal && !!this.currentFormsData.nexiForm.id) {
        this.saveData(this.temporaryFormsData.nexiForm);
      }
    },
    "temporaryFormsData.creditCardForm.status"(newVal, oldVal) {
      if (!newVal && oldVal && !!this.currentFormsData.creditCardForm.id) {
        this.saveData(this.temporaryFormsData.creditCardForm);
      }
    },
    "reactiveDefaultPaymentProcessors.paymentAutomationForm.data.configuration_id"(
      newVal
    ) {
      this.currentFormsData.paymentAutomationForm.data.configuration_id =
        newVal;
      this.temporaryFormsData.paymentAutomationForm.data.configuration_id =
        newVal;
    },
    "reactiveDefaultPaymentProcessors.paymentAutomationForm.status"(newVal) {
      this.currentFormsData.paymentAutomationForm.status = newVal;
      this.temporaryFormsData.paymentAutomationForm.status = newVal;
    }
  }
};
</script>
